// ==LICENSE-BEGIN==
// Copyright 2017 European Digital Reading Lab. All rights reserved.
// Licensed to the Readium Foundation under one or more contributor license agreements.
// Use of this source code is governed by a BSD-style license
// that can be found in the LICENSE file exposed on Github (readium) in the project repository.
// ==LICENSE-END==

import {
    XmlObject,
    XmlXPathSelector,
} from "@utils/xml-js-mapper";

@XmlObject({
    ds: "http://www.w3.org/2000/09/xmldsig#",
    enc: "http://www.w3.org/2001/04/xmlenc#",
    encryption: "urn:oasis:names:tc:opendocument:xmlns:container",
    ns: "http://www.idpf.org/2016/encryption#compression",
})
export class Compression {

    // XPATH ROOT: /encryption:encryption/enc:EncryptedData/enc:EncryptionProperties/
    // enc:EncryptionProperty/ns:Compression

    @XmlXPathSelector("@Method")
    public Method!: string;

    @XmlXPathSelector("@OriginalLength")
    public OriginalLength!: string;
}
